import { Component } from "react";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import { callAPI } from "../../assets/Js/backendCommunication";

import projectSettings from '../../assets/Js/projectSettings';

import { Spinner } from "../../Components/Spinner/Spinner";

import JoinGym from "../JoinGym/JoinGym";
import { connect } from "react-redux";
import { closeModel } from "../../assets/Js/closeModel";

const mapStateToProp = (state) => {
  return {
    selectedGym: state.selectedGym,
    userData: state.userData,
  };
};

export default connect(
  mapStateToProp,
  null
)(
  class UpdatePayment extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isLoading: false,
      };
    }

    componentDidMount() {
      if (this.props.userData.Role === "owner") {
        this.updatePayment();
      }
    }

    updatePayment = async () => {
      let gymId = this.props.selectedGym.value;

      let url =
        this.props.userData.Role === "owner"
          ? `${projectSettings.baseUrl}/subscriptions/gymportal`
          : `${projectSettings.baseUrl}/subscriptions/athleteportal/${gymId}`;

      let header = true;
      let type = "GET";
      let token = getPlainToken();
      let data = null;
      let response = "";

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, JSON.stringify(data), token);

      if (response) {
        console.log("redirect url of stripe:", response);
        apiResponseToast(
          response.status,
          "connectwithstripe",
          response.data.message
        );
        // resetting values
        this.setState({ isLoading: false });
        if (response.type === "error") {
        } else if (response.type === "success") {
          //  redirection
          window.location.replace(response.data.RedirectUrl);

          closeModel(this.props.modalId);
        }
        return true;
      }
    };

    render() {
      return (
        <div>
          {this.props.userData.Role === "athlete" ? (
            <JoinGym
              resetOnCloseModal={this.props.resetOnCloseModal}
              move={this.updatePayment}
              spin={true}
            />
          ) : (
            <>
              {this.state.isLoading ? (
                <Spinner />
              ) : (
                <div className="h3 mt-5 mb-5 text-center">Unable To Update</div>
              )}
            </>
          )}
        </div>
      );
    }
  }
);
